import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

const bingDesktop178100Raw = {
  componentType: AdPlacementsComponentTypes.AdPlacementPreview,
  aspectRatio: 1.78,
  type: 'BingSingleImage',
  associationType: 'ImageMedia178X100',
  imagePreviewHeight: 45,
  minimumRequirements: 0,
  minSize: [624, 350],
  localizedText: {
    previewTypeStringKey: _TL_('Bing desktop single-image extension'),
    stringKey: _TL_('1.78 : 1'),
  },
  previewSettings: {
    showImage: true,
    showLongHeadline: true,
    showDescription: true,
    showUrl: true,
    showMultipleLineLongHeadline: true,
    showUrlMultiline: true,
    showMultipleDescription: true,
  },
  styleOverrides: {
    previewContent: {
      border: '0.5px solid #ddd',
      width: 608,
      height: 110,
      padding: 3,
    },
    imageContainer: {
      float: 'right',
      transform: 'translate(20px,20px)',
      width: '100px',
      height: '75px',
      margin: '8px',
    },
    textContainer: {
      margin: '4px 8px 0px 8px',
    },
    longHeadline: {
      fontWeight: '400',
      fontSize: '20px',
      lineHeight: '24px',
      height: '28px',
      overflow: 'hidden',
    },
    finalUrl: {
      overflow: 'hidden',
      color: '#0b6a0b',
      fontSize: '14px',
      height: '20px',
    },
    description: {
      color: '#333',
      fontSize: '13px',
    },
  },
};

export default bingDesktop178100Raw;
